import CircularProgressWithLabel from "../../../../components/circularProgressWithLabel";

/**
 * Componente visual do cronômetro (anel de progresso 0–60s).
 *
 * Só é exibido quando há contagem ativa, existe um tempo selecionado, não está
 * em carregamento e a largura da tela comporta o indicador (>= 1350px).
 * A lógica/controle do timer vive no hook `useCronometro`.
 */
export default function Cronometro({
  counter,
  selectTime,
  loadingCronometro,
  windowWidth,
}) {
  const isCounting = counter || counter === 0;
  const hasSelectTime = selectTime || selectTime === 0;

  if (!isCounting || !hasSelectTime || loadingCronometro || windowWidth < 1350) {
    return null;
  }

  return <CircularProgressWithLabel value={counter} />;
}
